export default {
    methods: {
        clearStorage() {
            localStorage.clear();
        },
        getInitiative() {
            if (!localStorage.getItem('initiatief')) return false;
            return JSON.parse(localStorage.getItem('initiatief'));
        },
        updateInitiative(initiative, link) {
            localStorage.setItem('initiatief', JSON.stringify({
                name: initiative, link: link
            }))
        },
        getPhase() {
            if (!localStorage.getItem('fase')) return false;
            return JSON.parse(localStorage.getItem('fase'));
        },
        updatePhase(phase, link) {
            localStorage.setItem('fase', JSON.stringify({
                name: phase, link: link
            }))
        },
        getTarget() {
            if (!localStorage.getItem('doel')) return false;
            return JSON.parse(localStorage.getItem('doel'));
        },
        updateTarget(target, link) {
            localStorage.setItem('doel', JSON.stringify({
                name: target, link: link
            }))
        },
        /**
         * Reset any stored knowledge about what is selected in terms of situation.
         * At max there are four levels: `empty (0)`, `initiatief (1)`, `fase (2)`, `doel (3)`.
         * @param { int } currentLevel The level to reset to, typically the level of the current view.
         */
        resetSituationDetails(currentLevel) {
            let remove = ['initiatief', 'fase', 'doel']
            if (currentLevel == 1)
                remove = remove.slice(1)
            if (currentLevel == 2)
            remove = remove.slice(2)
            if (currentLevel == 3)
                remove = [];
            remove.forEach(r => {
                if (localStorage.getItem(r)) {
                    localStorage.removeItem(r);
                }
            });
        },
        getSituationDetails() {
            let result = [];
            if (this.getInitiative())
                result.push(this.getInitiative());
            if (this.getPhase())
                result.push(this.getPhase());
            if (this.getTarget())
                result.push(this.getTarget());
            return result;
        },
        getSituationAsString() {            
            let names = [];
            this.getSituationDetails().forEach(item => {
                names.push(item.name);
            });
            return names.join(' - ');
        },
        addMethod(comparisonItemId, methodId) {
            let selectedMethods = this.getSelectedMethods(comparisonItemId);
            selectedMethods.push(methodId);
            this.saveComparisonItem(comparisonItemId, selectedMethods)
        },
        deleteMethod(comparisonItemId, methodId) {
            let selectedMethods = this.getSelectedMethods(comparisonItemId);
            let index = selectedMethods.indexOf(methodId);
            if (index !== -1) {
                selectedMethods.splice(index, 1);
            }
            this.saveComparisonItem(comparisonItemId, selectedMethods)
        },
        saveComparisonItem(id, methods) {
            let item = JSON.stringify({
                id: id, methods: methods
            });
            localStorage.setItem('comparedItems', item);
        },
        getComparisonItem(id) {
            let item = false;
            if (localStorage.getItem('comparedItems')) {
                let stored = localStorage.getItem('comparedItems');
                if (stored.id == id) {
                    item = stored;
                }
            }
            return item;
        },
        getSelectedMethods(id) {
            let selectedMethods = [];
            let comItem = this.getComparisonItem(id);
            if (comItem && comItem.methods) {
                selectedMethods = comItem.methods;
            }
            return selectedMethods;
        },
        addHiddenTip(tipId) {
            let hiddenTips = this.getHiddenTips();
            hiddenTips.push(tipId);
            localStorage.setItem('hiddenTips', JSON.stringify(hiddenTips));
        },
        deleteHiddenTip(tipId) {
            let hiddenTips = this.getHiddenTips();
            let index = hiddenTips.indexOf(tipId);
            if (index !== -1) {
                hiddenTips.splice(index, 1);
            }
            localStorage.setItem('hiddenTips', JSON.stringify(hiddenTips));
        },
        getHiddenTips() {
            let hiddenTips = [];
            if (localStorage.getItem('hiddenTips')) {
                hiddenTips = JSON.parse(localStorage.getItem('hiddenTips'));
            }
            return hiddenTips;
        },
    }
}